module.exports = __webpack_public_path__ + "static/media/jumbo.34c03297.jpg";